module.exports = __webpack_public_path__ + "img/file.45d28107.jpg";